import {Component, OnInit, ViewChild} from "@angular/core";
import {AuthService} from "../../service/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../../service/member/member.service";
import {Member, MemberPage, createMember} from "../../service/member/member";
import {ModalDirective} from "ngx-bootstrap";
import {GtmService} from "../../service/gtm/gtm.service";
import {ShareService} from "app/service/share/share.service";

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss'],
  providers: [ShareService, MemberService]
})
export class ManagementComponent implements OnInit {

  page: number = 1;
  search: string = '';

  members: MemberPage;

  constructor(private shareService: ShareService,
              private memberService: MemberService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private gtmService: GtmService,
              private router: Router) {
    if (!authService.hasManager()) {
      this.router.navigateByUrl('/member/mypage');
      return;
    }

    this.getMe();
    this.getMembers(this.page);
    this.getCards();
  }

  ngOnInit() {
  }

  me: Member;
  getMe() {
    this.shareService.awaitMe().subscribe(
      me => {
        this.me = me;
      }
    );
  }

  getMembers(page: number) {
    this.page = page;
    this.memberService.getMyteam(page, this.search, false).subscribe(
      members => {
        this.members = members;
        // console.log(members)
        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '멤버관리',
          'breadcrumb': 'Home > Member > 멤버관리'
        });
      }
    );
  }

  cards: any[] = [];
  getCards() {
    this.memberService.getMyteamCard().subscribe(
      cards => {
        this.cards = cards
        // console.log(cards)
      }
    )
  }

  onPageChanged(event: any) {
    if (event.page == this.page) return;
    this.getMembers(event.page);
  }

  onSearch(term: string) {
    this.page = 1;
    this.search = term;
    this.getMembers(this.page);
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  hasManager() {
    return this.authService.hasManager();
  }

  /////////// modal /////////
  @ViewChild('modal') modal: ModalDirective;
  isModalShown: boolean = false;

  iptMember: createMember;
  onShowModal(member: Member) {
    this.iptMember = new createMember();
    this.iptMember.cardNo = '';

    if(!member) {
      this.isModalShown = true;
      this.modal.show();
    } else {
      this.iptMember.id = member.id;
      this.iptMember.email = member.email;
      this.iptMember.role = member.role;
      this.iptMember.team = { id: member.team.id };
      this.iptMember.location = { key: member.location.key };
      this.iptMember.cardNo = member.cardNo;

      this.isModalShown = true;
      this.modal.show();
    }

  }

  onHide(): void {
    this.isModalShown = false;
  }

  onCreateMember(form: any) {
    if (!form.email) {
      window.alert('이메일을 입력해 주세요.');
      return;
    } else if (!form.role && !this.iptMember.id) {
      window.alert('권한을 선택해 주세요.');
      return;
    } else if (!form.cardNo) {
      window.alert('보안카드번호를 선택해 주세요.');
      return;
    }

    form.team = { id: this.me.team.id }
    form.location = { key: this.me.location.key }

    this.iptMember = {...this.iptMember, ...form}

    if(this.iptMember.id) {
      delete this.iptMember.location

      this.memberService.updateMember(this.iptMember.id, this.iptMember).subscribe(
        member => {
          window.alert('해당 계정이 수정되었습니다.');
          this.modal.hide();
          this.getMembers(this.page);
        },
      )
    } else {
      this.memberService.createMember(this.iptMember).subscribe(
        member => {
          window.alert('해당 계정이 생성되었습니다.');
          this.modal.hide();
          this.getMembers(this.page);
        },
        error => {
          if (error.status == 400) {
            let body = JSON.parse(error._body);
            if (body['message'] == 'member already exist') {
              window.alert('동일 이메일 계정이 존재합니다.');
            } else if (body['message'] == 'limit account') {
              window.alert('더 이상 계정을 생성할 수 없습니다.');
            }
          }
        }
      );
    }
  }

  onLock(member: Member) {
    if (window.confirm('멤버를 비활성화하시겠습니까?')) {
      this.memberService.lock(member.email).subscribe(
        member => {
          this.getMembers(this.page);
          window.alert(`[${member.email}] 계정이 비활성화되었습니다.`);
        }
      );
    }
  }

  onUnlock(member: Member) {
    if(this.authService.isManager()){
      alert('활성화를 원하시면 커뮤니티팀에 문의해 주세요.')
    }
    else if(this.authService.isAdmin()) {
      if (window.confirm('멤버를 활성화하시겠습니까?')) {
        this.memberService.unlock(member.email).subscribe(
          member => {
            this.getMembers(this.page);
            window.alert(`[${member.email}] 계정이 활성화되었습니다.`);
          },
          error => window.alert('계정 갯수 제한으로 활성화할 수 없습니다.')
        );
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/member/management/management.component.ts